import React from 'react';
import {
  createStackNavigator,
  StackNavigationProp,
} from '@react-navigation/stack';
import { RouteProp } from '@react-navigation/native';
import { Platform } from 'react-native';
import CondoScreen from '../features/condoLanding';
import NewsScreen from '../features/news';
import GalleryScreen from '../features/gallery';
import LedgerScreen from '../features/ledger';
import CommunityCalendarScreen from '../features/community-calendar';
import CommunityAgendaScreen from '../features/community-agenda';
import {
  ServiceRequestScreen,
  CreateServiceRequestScreen,
} from '../features/servicerequest';
import FeedbackScreen from '../features/feedback';
import TestDynamicFormScreen from '../features/dynamicform/Contest';

import { RootStackParamList, RouteNames } from './condoTypes';

const tabTitle = (text: string) =>
  Platform.select({ web: text, default: 'Zonetail PMS' });
const ExploreStack = createStackNavigator<RootStackParamList>();

function RootNavigator() {
  return (
    <ExploreStack.Navigator initialRouteName={RouteNames.Condo}>
      <ExploreStack.Screen
        name={RouteNames.Condo}
        component={CondoScreen}
        options={{
          headerShown: false,
          title: tabTitle('Condo'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.News}
        component={NewsScreen}
        options={{
          headerShown: false,
          title: tabTitle('News'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.Gallery}
        component={GalleryScreen}
        options={{
          headerShown: false,
          title: tabTitle('Gallery'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.CommunityCalendar}
        component={CommunityCalendarScreen}
        options={{
          headerShown: false,
          title: tabTitle('Community Calender'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.CommunityAgenda}
        component={CommunityAgendaScreen}
        options={{
          headerShown: false,
          title: tabTitle('Community Agenda'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.Ledger}
        component={LedgerScreen}
        options={{
          headerShown: false,
          title: tabTitle('Ledger'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.ServiceRequest}
        component={ServiceRequestScreen}
        options={{
          headerShown: false,
          title: tabTitle('Service Request'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.CreateServiceRequest}
        component={CreateServiceRequestScreen}
        options={{
          headerShown: false,
          title: tabTitle('Service Request'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.Feedback}
        component={FeedbackScreen}
        options={{
          headerShown: false,
          title: tabTitle('Feedback'),
        }}
      />
      <ExploreStack.Screen
        name={RouteNames.Contest}
        component={TestDynamicFormScreen}
        options={{
          headerShown: false,
          title: tabTitle('Contest'),
        }}
      />
    </ExploreStack.Navigator>
  );
}

export default RootNavigator;
